import { LinkWrap } from '../../../navigation/LinkWrap';

import { ProductEmbedType } from '../ProductEmbed';

type TextProductsProps = {
  filteredProducts: ProductEmbedType[];
};

export const TextProducts = ({ filteredProducts }: TextProductsProps) => {
  return (
    <ul className="ProductEmbed [*_+_*]:mt-4 max-w-[620px] list-disc p-4">
      {filteredProducts.map((product, index) => {
        const { title, url, title_override } = product;
        return (
          <li key={index}>
            <LinkWrap className="text-neutral" href={url} target="_blank">
              {title_override || title}
            </LinkWrap>
          </li>
        );
      })}
    </ul>
  );
};
